export const CVReviewAltVal = [
	'overview',
	'pdfreview',
	'photoreview'
];
